import { useBoolean } from 'aa_common/front-end/hooks'

export const useAIAssistantDrawer = () => {
  const [visible, setTrue, setFalse] = useBoolean(false)

  return {
    visible,
    closeDrawer: () => setFalse(),
    openDrawer: () => setTrue(),
  }
}
